$(document).on("turbolinks:load", () => {

  // Accordion-card用
  $(".accordion-card .header-toggle").on("click", function(){
    $(this).parent().next('.card-body').slideToggle();
    $(this).toggleClass("open");
  });

  // Table用
  $(".linkCopyButton").on("click", function(){
    var link = $(this).next('#copyTarget').val();

    // 選択しているテキストをクリップボードにコピーする
    navigator.clipboard.writeText(link)
    $('.copied-url-modal').fadeIn();
    setTimeout(function(){
      $('.modal').fadeOut();
    },1500);
  });

	$('.modal' ).on("click", function(){
		$(this).fadeOut();
	});
});
